<div [attr.name]="groupName()">
  <div
    class="flex items-center justify-between cursor-pointer"
    [class]="accordionClass()"
    (click)="toggle()">
    <h5 [class]="titleClass()">
      {{ title() }}
    </h5>

    <!-- expanded/collapse arrow -->
    <lib-chevron-down-icon
      [iconClass]="
        'text-neutral-500 size-4 ' + (isOpen() ? 'rotate-180' : '')
      " />
  </div>

  @if (isOpen()) {
    <div [class]="detailsClass()">
      <ng-content />
    </div>
  }
</div>
